import { Button, SvgArrowLeft, SvgCloseCross } from "@getgrover/ui";
import { HeaderContainer, HeaderTitle } from "./styles";

export interface DrawerHeaderProps {
  title?: string;
  onBackButtonClick?: () => void;
  onCloseButtonClick?: () => void;
}

export const DrawerHeader: React.FC<DrawerHeaderProps> = ({
  onBackButtonClick,
  onCloseButtonClick,
  title,
}) => {
  return (
    <HeaderContainer>
      {onBackButtonClick && (
        <Button
          variant="Secondary"
          iconOnly
          size="M"
          onClick={onBackButtonClick}
        >
          <SvgArrowLeft />
        </Button>
      )}
      <HeaderTitle>{title}</HeaderTitle>
      {onCloseButtonClick && (
        <Button variant="Grey" iconOnly size="M" onClick={onCloseButtonClick}>
          <SvgCloseCross />
        </Button>
      )}
    </HeaderContainer>
  );
};
